import React, { FC, ReactNode } from 'react';

import Markdown from '@common/components/Markdown';
import { BackgroundImgixWrapper } from '@common/components/BackgroundImgixWrapper';
import { Heading4 } from '@common/components/Typography';
import { defaultTheme } from '@common/theme';
import {
  ButtonSection,
  SolidColorBackground,
  StyledHero,
  Summary,
  TextSection,
} from './SectionHero.styles';

type SectionHeroProps = {
  title: ReactNode;
  summary: string | Node;
  backgroundUrl: string;
  isCompact?: boolean;
  renderButton?: JSX.Element;
  imageLabel?: string;
};

export const SectionHero: FC<SectionHeroProps> = ({
  backgroundUrl,
  summary,
  title,
  isCompact,
  renderButton,
  imageLabel,
}) => (
  <section>
    <BackgroundImgixWrapper src={backgroundUrl} label={imageLabel} customHeight="initial">
      <StyledHero isCompact={isCompact}>
        {!backgroundUrl && <SolidColorBackground />}
        <TextSection>
          <Heading4 tag="h1" color={defaultTheme.defaultColors.white}>
            {title}
          </Heading4>
          <Summary>
            <Markdown text={summary} />
          </Summary>
        </TextSection>
        <ButtonSection>{renderButton}</ButtonSection>
      </StyledHero>
    </BackgroundImgixWrapper>
  </section>
);
